// extracted by mini-css-extract-plugin
module.exports = {"portrait":"ClassDetail_portrait_2Qz-s","variantWealth":"ClassDetail_variantWealth_1fvBl","funds":"ClassDetail_funds_1oPrt","darkSide":"ClassDetail_darkSide_YlO_D"};